import { useQuery } from '@tanstack/react-query';
import { getAvgResubmissions } from '../services/AnalyticReportsService';
export default function useAvgResubmissions(filters) {
    return useQuery(['avgResubmissions', filters.values.dateRange], () => getAvgResubmissions(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
